import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import { Chip, Typography } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import RenderingEngine from '.';
import { fetchSelectedQption } from '../actions';
import styles from '../index.module.scss';
import { IRenderingEngine, QuestionResponse } from '../interfaces/index.type';
import {
  getSortedOption,
  getStylesForChipInteractions,
  InteractionsEnum,
  selectedOptionChipStyles
} from '../utlis';
import { toast } from '@primitives/Toast';

const Options: React.FC<IRenderingEngine> = props => {
  const {
    question,
    register,
    error,
    toggleLoading,
    interactionType,
    setValue,
    lan,
    customerId,
    source,
    unregister,
    clearErrors,
    ...remainingProps
  } = props;
  const [moreQuestion, setmoreQuestion] = useState<Array<QuestionResponse>>([]);
  const [selectedChip, setselectedChip] = useState<string>();
  const { text, options, mandatory, referenceId, defaultOptionReferenceId } = question;
  // TODO: Remove hardcoded value for const chip
  // const chip = useMemo(() => text === 'Mode of contact' || text === 'Reason for refusing', [props]);
  const chip = true;
  const sortedOption = useMemo(() => getSortedOption(options), [options]);
  const defaultSelectedOption = options?.find(
    option => option.referenceId === defaultOptionReferenceId
  );

  const successCallback = useCallback((res: Array<QuestionResponse>) => {
    toggleLoading(false);
    setmoreQuestion([...res]);
  }, []);

  const failureCallback = useCallback(() => {
    toggleLoading(false);
    toast('something went wrong, please try selecting the option again', { type: 'error' });
  }, []);

  const handleChipChange = (changeEvent: string) => {
    setselectedChip(changeEvent);
    toggleLoading(true);
    fetchSelectedQption(
      lan,
      customerId,
      changeEvent,
      successCallback,
      interactionType,
      failureCallback
    );
  };

  const renderChips = useMemo(
    () => (
      <>
        {sortedOption.map(option => (
          <div key={`${source}_${option.referenceId}`}>
            <input
              id={`${source}_${option.referenceId}`}
              {...register(`${source}_${referenceId}_option`, {
                required: mandatory,
                onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChipChange(e.target.value)
              })}
              // onChange={() => handleChipChange(option.referenceId)}
              type={'radio'}
              name={`${source}_${referenceId}_option`}
              value={option.referenceId}
              defaultValue={selectedChip}
            />
            <label htmlFor={`${source}_${option.referenceId}`}>
              <Chip
                label={option.text}
                wrapperClasses={cx([
                  {
                    [selectedOptionChipStyles(option?.metadata?.interactionLevel)]:
                      option.referenceId === selectedChip
                  },
                  getStylesForChipInteractions(
                    option?.metadata?.interactionLevel,
                    InteractionsEnum.HOVER
                  ),
                  'cursor-pointer'
                ])}
                labelClasses={styles.text}
              />
            </label>
          </div>
        ))}
      </>
    ),
    [selectedChip, source]
  );

  useEffect(() => {
    if (defaultSelectedOption) {
      const selectedOptionReferenceId = defaultSelectedOption?.referenceId;
      setselectedChip(selectedOptionReferenceId);
      setValue(`${source}_${referenceId}_option`, selectedOptionReferenceId);
      fetchSelectedQption(
        lan,
        customerId,
        selectedOptionReferenceId,
        successCallback,
        interactionType,
        failureCallback
      );
    }
    return () => {
      setValue(`${source}_${referenceId}_option`, undefined);
      unregister(`${source}_${referenceId}_option`);
      clearErrors(`${source}_${referenceId}_option`);
    };
  }, [defaultSelectedOption]);

  return (
    <>
      <div className={styles.input}>
        <Typography variant={'p4'} as={'p'}>
          {text} {<RequiredIcon />}
        </Typography>
        <>
          <div className={cx(styles.chipContainer)}>{renderChips}</div>
          {error?.[`${source}_${referenceId}_option`] && (
            <Typography variant="p5" className={styles.errorText}>
              Please select {text}
            </Typography>
          )}
        </>
      </div>
      <div key={`${source}_${referenceId}_${text}`}>
        {moreQuestion.map(question => (
          <RenderingEngine
            key={`${source}_${referenceId}`}
            {...remainingProps}
            register={register}
            question={question}
            error={error}
            setValue={setValue}
            toggleLoading={toggleLoading}
            interactionType={interactionType}
            lan={lan}
            customerId={customerId}
            unregister={unregister}
            clearErrors={clearErrors}
            source={source}
          />
        ))}
      </div>
    </>
  );
};

export default Options;
